import LoadingSpinner from "@components/LoadingSpinner";
import * as Sentry from "@sentry/react";
import { JSX } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";
import { useUserData } from "../../app/hooks/auth";
import { buildQueryString } from "../../app/utils/api.util";

export const RequireAuth = ({
  children,
}: { children: JSX.Element }): JSX.Element => {
  const auth = useAuth();
  const { isLoading, user } = useUserData();
  const location = useLocation();

  if (auth.isLoading || isLoading) {
    return <LoadingSpinner />;
  }

  if (!auth.isAuthenticated) {
    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    return (
      <Navigate
        to={buildQueryString("/login", { redirect: currentPath })}
        replace
      />
    );
  }

  Sentry.setUser(user ? { id: user.id } : null);
  Sentry.setTag("user-role", user?.role);

  return children;
};
